import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const cmsList = () => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/cmsList',
        method: 'get',
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/sino-columnConfig/columnConfig/submit',
        method: 'post',
        data: row
    })
}

